import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const usePayoutAllSars = () => {
  const { mutate: payoutAllSars, isPending } = useAppMutation([QueryKey.CREATE_SCENARIO_GRANT], {
    mutationFn: ({ scenarioId }: { scenarioId: string }) =>
      ApiService.post({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId, 'grants-for-scenario', 'payout-all'],
      }),
  });
  return { payoutAllSars, isPending };
};
